import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  body: string;
  onRetry?: () => void;
}

export function ErrorState({ title, body, onRetry }: Props) {
  const { t } = useTranslation('common');

  return (
    <div className="state-card" role="alert">
      <h3>{title}</h3>
      <p>{body}</p>
      {onRetry ? (
        <button type="button" className="btn btn-primary" onClick={onRetry}>
          {t('retry')}
        </button>
      ) : null}
    </div>
  );
}
